import httpApi from './api/httpApi';
import useSWR from 'swr';

const DEFAULT_STOCK_URL = '/api/v1/stocks';

export const useDefaultStockSWR = () => {
    const fetchStock = (query): Promise<DefaultStock[]> => {
        return httpApi
            .get<{ stocks: DefaultStock[] }>(query)
            .then((res) => {
                return res.getData().stocks;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        DEFAULT_STOCK_URL,
        fetchStock,
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    return {
        stocks: data ? data : null,
        isLoadingStock: isLoading,
        isErrorStock: error,
        forceRefreshStock: mutate,
    };
};

export default useDefaultStockSWR;

interface DefaultStock {
    bc_location_code: string;
    bc_location_name: string;
}
